import { useState, useEffect } from "react";
import { useAccount, useChains } from "wagmi";

const useNetwork = () => {
  const { isDisconnected, address, chainId } = useAccount();
  const [isConnected, setIsConnected] = useState(false);
  const chains = useChains();

  useEffect(() => {
    if (!isDisconnected && address) {
      setIsConnected(true);
    } else {
      setIsConnected(false);
    }
  }, [isDisconnected, address]);

  const allValidChains = chains.map((chain) => chain.id);
  const validChain = allValidChains.includes(chainId);

  return { isConnected, validChain };
};

export default useNetwork;
